<template>
    <v-content>
      <v-container fluid style="position: relative">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card>
              <v-container fluid>
                <v-card-title>    
                  <v-btn icon href="/additional-pages">
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>  
                  {{ 'Additional Pages' | translate }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-form id="form" ref="form">
                    <v-row>
                      <v-col cols="12" sm="9" md="9">
                        <v-row v-if="errors">
                          <v-col cols="12" sm="12" md="12">
                            <v-alert
                              dense
                              v-for="(v, k) in errors"
                              :key="k"
                              outlined
                              type="error"
                            >{{ k }} {{ v }}</v-alert>
                          </v-col>
                        </v-row>

                        <v-row v-if="missing_name_error_message || missing_fields_error_message">
                          <v-col cols="12" sm="12" md="12">
                            <v-alert
                              dense
                              outlined
                              type="error"
                              v-if="missing_name_error_message" 
                            >
                            {{ missing_name_error_message | translate}}
                          </v-alert>
                            <v-alert
                              dense
                              outlined
                              type="error"
                              v-if="missing_fields_error_message" 
                            >
                            {{ missing_fields_error_message | translate}}
                          </v-alert>
                          </v-col>
                        </v-row>
                        
                        <v-tabs
                        v-model="nametabs"
                        >
                          <v-tabs-slider></v-tabs-slider>
                          <v-tab  
                            v-for="language in availablelanguages" :key="language.lang_id" 
                            :href="'#'+language.lang_code">
                            <span v-if="company_default_language===language.lang_code" 
                            style="color: #dc3545!important;">*</span>
                              {{ language.lang_name | translate}} 
                          </v-tab>
                        </v-tabs>
              
                        <v-tabs-items v-model="nametabs" >
                          <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                          <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              outlined
                              :label="page_name_display +language.lang_name| translate"
                              v-model="page_name[index]"
                              name="page_name"
                              autocomplete="off"
                              :rules="pagenameRules"
                              required
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                            
                            </v-text-field>
                          </v-col>
                        </v-row>
                        </v-tab-item>
                        </v-tabs-items>
                        
  
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                    v-model="page_type"
                                    :items="TypeOfPages"
                                    item-value="value"
                                    item-text="text"
                                    :label="'Page Type' | translate"
                                    outlined
                                    chips
                                    small-chips
                                    required
                                    :rules="pageTypeRules"
                                    :no-data-text="$t('No data available')"
                                >
                                <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                              <span class="theme--light text-caption font-weight-light" v-if="template_id != '' && (show_on_side_menu!=this.individualadditionalpage.show_on_side_menu)">{{'*Changes will reflect only after you logout' | translate}}</span>
                              <v-checkbox
                                :label="'Display on Side Menu?' | translate"
                                v-model="show_on_side_menu" 
                                name="show_on_side_menu"
                                >
                                <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>   

                              </v-checkbox>
                            </v-col>
                        </v-row>

                   
                        <v-tabs v-if="!campaignswitch"
                        v-model="tabs"
                        >
                          <v-tabs-slider></v-tabs-slider>
                          <v-tab  
                            v-for="language in availablelanguages" :key="language.lang_id" 
                            :href="'#'+language.lang_code">
                            <span v-if="company_default_language===language.lang_code" 
                            style="color: #dc3545!important;">*</span>
                              {{ language.lang_name | translate}} 
                          </v-tab>
                        </v-tabs>
              
                        <v-tabs-items v-model="tabs" v-if="!campaignswitch">
                            <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    outlined
                                    :label="page_title_display +language.lang_name| translate"
                                    v-model="page_title[index]"
                                    name="title"
                                    autocomplete="off"
                                  >
                                  <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>                            
                                  </v-text-field>
                                </v-col>
                              </v-row>
  
                              <v-row>
                                <v-col cols="12" sm="12">
                                  
                                  <div class="mb-3 mt-n2 pb-6"> <span class="title">{{template_body_display +language.lang_name| translate}}</span>
                                    <div class="d-flex resource-button">
                                        <div class="d-flex test-mail-input">
                                          <v-btn class="mr-4" @click="attachResource()" density="compact"><v-icon>mdi-plus</v-icon>{{"Resources" | translate}}</v-btn>
                                        </div>
                                    </div>
                                   
                                  </div>
                                    
                                    <template>
                                        <div id="app">
                                            <tiptap 
                                            v-model="page_content[index]"
                                            />
                                        </div>
                                    </template>
  
                                </v-col>
                              </v-row>
                            </v-tab-item>    
                        </v-tabs-items>  

                        <v-card outlined class="mt-6 pa-3" v-for="(emailtemplate,i) in emailtemplates" :key="i">
                            <v-row>
                              <v-col cols="11" sm="11" md="11" class="mt-n6">
                                <v-tabs
                                    v-model="campaigntabs[i]"
                                >
                                    <v-tabs-slider></v-tabs-slider>
                                    <v-tab  
                                    v-for="language in availablelanguages" :key="language.lang_id" 
                                    :href="'#'+language.lang_code">
                                    <span v-if="company_default_language===language.lang_code" 
                                    style="color: #dc3545!important;">*</span>
                                        {{ language.lang_name | translate}} 
                                    </v-tab>
                                </v-tabs>
                    
                                <v-tabs-items v-model="campaigntabs[i]">
                                    <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                                      
                                        <v-row>

                                        <v-col cols="2" sm="2" md="2" v-if="page_type=='faq'">
                                          <v-text-field
                                          outlined
                                          :label="rank_number_display| translate"
                                          v-model="emailtemplates[i]['rank_number'][index]"
                                          name="rank_number"
                                          autocomplete="off"
                                          required
                                          >
                                          <template #message="{ message }">
                                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                          </template>                            
                                          </v-text-field>
                                      </v-col>
                                      
                                        <v-col cols="10" sm="10" md="10">
                                            <v-text-field
                                            outlined
                                            :label="page_title_display+language.lang_name| translate"
                                            v-model="emailtemplates[i]['page_title'][index]"
                                            name="subject"
                                            autocomplete="off"
                                            required
                                            >
                                            <template #message="{ message }">
                                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                            </template>                            
                                            </v-text-field>
                                        </v-col>
                                        </v-row>

                                        <v-row>
                                        <v-col cols="12" sm="12">
                                            
                                            <div class="mb-3 mt-n2 pb-6"> <span class="title">{{template_body_display +language.lang_name| translate}}</span>
                                              <div class="d-flex resource-button">
                                                  <div class="d-flex test-mail-input">
                                                    <v-btn class="mr-4" @click="attachResource()" density="compact"><v-icon>mdi-plus</v-icon>{{"Resources" | translate}}</v-btn>
                                                  </div>
                                              </div>
                                            </div>
                                            
                                            <template>
                                                <div id="app">
                                                    <tiptap 
                                                    v-model="emailtemplates[i]['page_content'][index]"
                                                    />
                                                </div>
                                            </template>

                                        </v-col>
                                        </v-row>
                                    </v-tab-item>    
                                </v-tabs-items>  
                            </v-col>


                                <v-col cols="1" sm="1" md="1">
                                  <v-icon :disabled="!i" class="mr-2" v-on:click="handleDelete(i)" >delete</v-icon>
                                </v-col>

                            </v-row>
                      </v-card>

                        <v-row>
                            <v-col cols="12">
                                <v-card-text class="pb-4 title" v-if="canAddTemplate" @click="addTemplate" style="cursor: pointer" >{{ 'Add More' | translate}}
                                <v-icon >mdi-plus-box</v-icon>
                                </v-card-text>   
                            </v-col>
                        </v-row>
                        
  
                      </v-col>
                  
                      <v-col cols="12" sm="4" md="4"></v-col>
                    </v-row>
                  </v-form>
                  
                  <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    color="pink"
                    class="mx-2"
                    v-if="template_id != ''"
                    @click="submit"
                  >
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                  <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    color="pink"
                    class="mx-2"
                    v-if="template_id"
                    @click="update"
                  >
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                </v-card-text>
  
                            
              </v-container>
            </v-card>
         </v-col>
        </v-row>
      </v-container>

    <v-dialog v-model="recourcemodaldialog" persistent max-width="560">
      <v-card>
        <v-card-actions>
          <v-card-title class="headline"> <span v-if="addNewResource">{{ "Add Resource" | translate }} </span> <span v-else> {{ "Attach Resource" | translate }}</span> </v-card-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" @click="addNewResource=true" density="compact"><v-icon>mdi-plus</v-icon>{{"New Resource" | translate}}</v-btn>
        </v-card-actions>

        <v-container>
          <div v-if="!addNewResource">          
            <v-autocomplete
                v-model="selectedResource"
                :items="resources"
                item-value="resource_id"
                item-text="name"
                :label="'Select Resource' | translate"
                outlined
                chips
                small-chips
                required
                :rules="pageTypeRules"
                @change="resourceSelected()"
                :no-data-text="$t('No data available')"
            >
            <template #message="{ message }">
            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
            </template>
            </v-autocomplete>

            <v-row>
              <v-col cols="12" sm="12" md="12" class="mt-n3 pb-4">
                <h3>{{'Placeholders' | translate}}</h3>
                  <span class="pa-2" v-if="selectedResource"> {{"Use these placeholders while constructing Email" | translate}} </span>
                  <span class="pa-2" v-else> {{"No placeholders available" | translate}} </span>
                  <div>
                      <v-chip
                      class="ma-2 mb-4" v-if="placeholderimageresource"
                      @click="addplaceholder(placeholderimageresource)"
                      >
                      {{placeholderimageresource}}
                      </v-chip>
                      <span id="custom-tooltip">{{"Copied to Clipboard!" | translate}} </span>
                  </div>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-form id="resource-form" ref="resourceform">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      outlined
                      :label="'Resource Name' | translate"
                      v-model="resource_name"
                      name="resource_name"
                      autocomplete="off"
                      :rules="resourceameRules"
                      required
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                            
                    </v-text-field>
                  </v-col>
                </v-row>

                  <v-row>
                      <v-col cols="12" sm="12">
                          <v-autocomplete
                              v-model="resourceType"
                              :items="TypeOfresources"
                              item-value="value"
                              item-text="text"
                              :label="'Resource Type' | translate"
                              outlined
                              chips
                              small-chips
                              required
                              :rules="resourceTypeRules"
                              :no-data-text="$t('No data available')"
                          >
                          <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-autocomplete>
                      </v-col>
                  </v-row>

                  <div v-if="resourceType">
                      <v-row v-if="resourceType=='image'">
                          <v-col>
                              <v-file-input
                                  id="resource_image"
                                  name="filename"
                                  v-model="image_link"
                                  outlined
                                  chips
                                  required
                                  :label="'Image Upload' | translate"
                                  @change="onFileSelected"
                              >
                                  <template #message="{ message }">
                                  {{
                                      curLanguage.lang_code == "en"
                                      ? message
                                      : $t(message)
                                  }}
                                  </template>
                              </v-file-input>
                          </v-col>
                      </v-row>

                      <v-row v-else>
                          <v-col>
                              <v-text-field
                                  outlined
                                  :label="'Video Resource Link' | translate"
                                  v-model="video_link"
                                  name="video"
                                  autocomplete="off"
                                  :rules="videoLinkRules"
                                  required
                                  >
                                  <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>                            
                              </v-text-field>
                          </v-col>
                      </v-row>
                  </div>
                  
                  <v-btn class="ml-2" @click="addNewResource=false">
                    {{"Cancel" | translate}}
                  </v-btn>

                  <v-btn class="ml-2 white--text" :color="primary_color" @click="saveResource()">
                    {{"Save" | translate}}
                  </v-btn>
             </v-form>
          </div>


        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="recourcemodaldialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-content>
  </template>  
  
  <script>
  import {
    FETCH_LANGUAGES,
    FETCH_PAGE_RESOURCES,
    FETCH_COMPANY_SETTINGS,
    ADD_ADDITIONAL_PAGE_RESOURCE,
    FETCH_INDIVIDUAL_ADDITIONAL_PAGE,
    ADD_COMPANY_PAGE,
    UPDATE_COMPANY_PAGE,
    RESET_STATE
  } from "@/store/actions.type";
  import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
  import tiptap from '@/components/tiptap/tiptap.vue'
  import store from "@/store"
  import { mapState } from "vuex"
  import { mapGetters } from "vuex"
  export default {
    name: "addcustomemailtemplate",
    async beforeRouteUpdate(to, from, next) {
      await store.dispatch(RESET_STATE)
      return next();
    },
    async beforeRouteEnter(to, from, next) {
      Promise.all([
          store.dispatch(RESET_STATE),
          await store.dispatch(FETCH_LANGUAGES, ""),
          await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile')
      ]).then(() => {
          store.commit(SET_LOADING, false)
        }) 

      if (to.params.id) {
        await store.dispatch(FETCH_INDIVIDUAL_ADDITIONAL_PAGE, to.params.id)
      }
  
      store.commit(SET_ROUTER_ENTER, false)
  
      return next();
    },
    async beforeRouteLeave(to, from, next) {
      await store.dispatch(RESET_STATE)
      next();
    },
    components: { tiptap }, 
    computed: {
      ...mapGetters(['admin','languages', 'individualadditionalpage', 'currentUser', 'curLanguage', 'companysettings','resources']),
      ...mapState({
        errors: state => state.additionalpage.pageerrors,
      }),
      pagenameRules(){  return [v => !!v || "Page name is required"]},
      pageTypeRules(){  return [v => !!v || "Page Type is required"]},
      resourceameRules(){  return [v => !!v || "Resource name is required"]},
      resourceTypeRules(){  return [v => !!v || "Resource Type is required"]},
      TypeOfresources(){
        return [
            {value: 'image', text:this.$t('Image')},
            {value: 'video', text:this.$t('Video')},
        ]
      },
      TypeOfPages(){
        return [
            {value: 'blank', text:this.$t('Blank Page')},
            {value: 'glossary', text:this.$t('Glossary Page')},
            {value: 'faq', text:this.$t('FAQ Page')}
        ]
      },
      availablelanguages(){
        let availablelanguages=[];
  
        let selectedLang = this.languages.filter(data =>data.lang_code == this.company_default_language)
        selectedLang.forEach((lang) => {
          availablelanguages.push(lang);
        });
        
        let otherlang = this.languages.filter(data =>data.lang_code != this.company_default_language)
        otherlang.forEach((lang) => {
          availablelanguages.push(lang);
        });
        return availablelanguages;
      },
      canAddTemplate(){
        if(this.page_type=='glossary' || this.page_type=='faq'){
            return true;
        }
        return false;
    },
  
    },
    async mounted () {
      if(!this.hasrequiredPermissions()){
        this.$router.push('/dashboard');
      }
  
      this.page_contentEdited = true;
      this.companymeta = JSON.parse(this.currentUser.company.company_meta);
      this.primary_color = this.companymeta.primary_color 
      this.company_default_language = this.currentUser.company.language.lang_code;
      this.tabs = this.currentUser.company.language.lang_code;
      this.nametabs = this.currentUser.company.language.lang_code;

      if(Object.keys(this.individualadditionalpage).length >0){
      this.template_id = this.individualadditionalpage.page_id
      this.page_type = this.individualadditionalpage.page_type
      this.show_on_side_menu = this.individualadditionalpage.show_on_side_menu
      
      if(this.individualadditionalpage.page_type=='glossary' || this.individualadditionalpage.page_type=='faq'){
        this.campaignswitch = true;
      }

      this.availablelanguages.forEach((lang, index) => {
          this.individualadditionalpage.page_names.forEach((itemname) => {
            if(lang.lang_code === itemname.lang_code){
                this.$set(this.page_name, index , itemname.page_name);
            }
          });
      });


      if(Object.keys(this.individualadditionalpage).length >0){
      if(this.campaignswitch){
        //initialize array with no values
          var content_number = 0;
          let iterator = 0;
          this.individualadditionalpage.page_contents.forEach((item1) => {
            content_number = item1.content_number;
            const found = (this.emailtemplates).some(el => el.content_number === content_number);
            if(content_number==item1.content_number && !found){
              iterator = iterator + 1;
              
              this.emailtemplates.push({ 
                  element_count: iterator,
                  content_number : item1.content_number,
                  rank_number : [],
                  page_title : [],
                  page_content : [],
              });
            }
          }); 

          this.individualadditionalpage.page_contents.forEach((item1) => {
              this.rank_number = [];
              this.page_title = [];
              this.page_content = [];
              this.availablelanguages.forEach((lang, index) => {
                this.individualadditionalpage.page_contents.forEach((item2) => {
                  if(lang.lang_code === item2.lang_code && item1.content_number === item2.content_number){
                      this.$set(this.rank_number, index , item2.rank_number);
                      this.$set(this.page_title, index , item2.page_title);
                      this.$set(this.page_content, index , item2.page_content) 
                  }
                });
            });

            var elementindex = this.emailtemplates.findIndex(item => item.content_number==item1.content_number);
            this.emailtemplates[elementindex].rank_number = this.rank_number;
            this.emailtemplates[elementindex].page_title = this.page_title;
            this.emailtemplates[elementindex].page_content = this.page_content;

          });
      }
      else{
        this.availablelanguages.forEach((lang,index) => {
            this.individualadditionalpage.page_contents.forEach((item) => {
            if(lang.lang_code === item.lang_code){
                this.$set(this.rank_number, index , item.rank_number);
                this.$set(this.page_title, index , item.page_title);
                this.$set(this.page_content, index , item.page_content) 
            }
            });
        });
      }
    }

    }
  
    },
    data: function() {
      return {
        template_id: null,
        page_name: [],
        template_language :null,
        primary_color:null,
        rank_number: [],
        page_title: [],
        page_content: [],
        page_names:[],
        additional_pages_template:[],
        company_default_language:null,
        page_type: null,
        tabs:null,
        nametabs:null,
        campaigntabs:[],
        missing_name_error_message:'',
        missing_fields_error_message:'',
        campaignswitch:false,
        emailtemplates:[],
        recourcemodaldialog : false,
        imageresource:[],
        selectedResource:null,
        placeholderimageresource:null,
        addNewResource:false,
        resource_name:null,
        show_on_side_menu:false,
        resourceType:null,
        rank_number_display : "Rank",
        page_name_display : 'Page Name in ',
        page_title_display : 'Title in ',
        template_body_display : 'Page Contents in ',
      }
    },
    watch: {
      // whenever template changes, this function will run
      page_content(newValue, oldValue) {
        if(oldValue){
          if(newValue !== oldValue){
            this.page_contentEdited = false;
          }
        }
      },
      page_type(newValue){
        if(newValue=='glossary'){
          this.page_title_display = 'Glossary Term in '
          this.page_content_body_display = 'Definition in '

        }
        if(newValue=='faq'){
          this.page_title_display = 'Faq Question in '
          this.page_content_body_display = 'Answer in '
        }
        if(newValue=='glossary' || newValue=='faq'){
          this.campaignswitch = true;
          if(this.emailtemplates.length==0){
            this.emailtemplates.push({ 
                faq_count: this.emailtemplates.length+1,
                rank_number : [],
                page_title : [],
                page_content : [],
            })
          }
        }
        else{
          this.campaignswitch = false;
          this.page_title_display = 'Title in '
          this.page_content_body_display = 'Page Contents in '
        }
    
      },
    },
    methods : {
      hasrequiredPermissions(){
        if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('has-access-to-additional-pages') ){
          return true;
        }
        return false;
      },
      resourceSelected(){
        let index = this.imageresource.findIndex(item => item.resource_id == this.selectedResource);
        this.placeholderimageresource = this.imageresource[index].place_holder;
      },
      saveResource(){

        if (this.$refs.resourceform.validate()) {
                var formData = new FormData(document.getElementById("resource-form"));
                
                formData.set("name", this.resource_name);
                formData.set("resource_type", this.resourceType);
                
                if(this.resourceType=='image'){
                    if (this.image_link != null) {
                        formData.set("file", this.image_link);
                    }
                }
                else if(this.resourceType=='video'){
                    if (this.video_link != null) {
                        formData.set("file", this.video_link);
                    }
                }
             
                this.$store.dispatch(ADD_ADDITIONAL_PAGE_RESOURCE, formData).then((resp) => {
                    if (
                        resp != undefined &&
                        resp.hasOwnProperty("success") &&
                        resp.success
                    ) {
                        store.commit(SET_LOADING, false);
                        store.commit(SET_SNACKBAR, {
                        status: true,
                        message: "Resource created successfully",
                        });
                        this.addNewResource = false;
                        this.attachResource();
                    } else {
                        store.commit(SET_LOADING, false);
                    }
                });

        }
      },
      addTemplate () {
          if(this.emailtemplates.length==15){
              alert("You cannot add more than 15 templates");
              return;
          }
          this.emailtemplates.push({ 
            faq_count: this.emailtemplates.length+1,
            rank_number : [],
            page_title : [],
            page_content : [],
          })
  
      },
      async attachResource(){
        await this.$store.dispatch(FETCH_PAGE_RESOURCES, '').then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                this.$store.commit(SET_LOADING, false);
                store.commit(SET_SNACKBAR, {status: true, message: this.$t('Image Resources fetched')})
                this.imageresource = resp.data;
            }
            else{
                this.$store.commit(SET_LOADING, false);
            }
        });
        this.recourcemodaldialog = true
      },
      addplaceholder(placeholder) {
          const insertText = placeholder
          if (!insertText.length) return
  
          navigator.clipboard.writeText(placeholder).then(() => {
            /* clipboard successfully set */
            document.getElementById("custom-tooltip").style.display = "inline";
            setTimeout( function() {
                document.getElementById("custom-tooltip").style.display = "none";
            }, 1000);
          }, () => {
            /* clipboard write failed */
          });
      },
      submit: function() {
        if (this.$refs.form.validate()) {
          let data = {
              page_type:this.page_type,
              show_on_side_menu:this.show_on_side_menu
            }

          this.availablelanguages.forEach((lang,index) => {
              if(this.page_name[index]){
                this.missing_name_error_message = "";
                  this.page_names.push({
                      "lang_code": lang.lang_code,
                      "page_name": this.page_name[index],
                  })
              }
              else{
                this.missing_name_error_message = "You need to fill Page Names in all Languages. ";
              }
            });
          data["page_names"] = this.page_names;
          
          if(this.campaignswitch){
              this.additional_pages_template = [];
              this.emailtemplates.forEach((et,noindex) => {
                  this.availablelanguages.forEach((lang,index) => {
                      if(et.page_title[index]!=""){
                          if(et.page_title[index]!=null){
                              this.additional_pages_template.push({
                                  "lang_code": lang.lang_code,
                                  "content_number": noindex+1,
                                  "rank_number": et.rank_number[index],
                                  "page_title": et.page_title[index],
                                  "page_content": et.page_content[index],
                              });
                          }
                      }
                  });
              });
          }
          else{
              this.additional_pages_template = [];
              this.availablelanguages.forEach((lang,index) => {
                if(this.page_title[index]!=""){
                  if(this.page_title[index]!=null){
                    this.additional_pages_template.push({
                        "lang_code": lang.lang_code,
                        "content_number": 1,
                        "rank_number": this.rank_number[index],
                        "page_title": this.page_title[index],
                        "page_content": this.page_content[index],
                    })
                  }
                }
              });
          }

          data["page_contents"] = this.additional_pages_template;

          if(data["page_contents"].length==0){
            this.missing_fields_error_message = "You need to fill the at least one language, Title and Page Contents";
            return;
          }

          if(this.missing_name_error_message){
            return;
          }

          if(this.missing_name_error_message){
            return;
          }

            this.$store.dispatch(ADD_COMPANY_PAGE, data).then((resp) => {
                if (
                    resp != undefined &&
                    resp.hasOwnProperty("success") &&
                    resp.success
                ) {
                    store.commit(SET_LOADING, false);
                    store.commit(SET_SNACKBAR, {
                    status: true,
                    message: "Page Added successfully",
                    });
                    this.$router.push({ name: "additionalpages" });
                } else {
                    store.commit(SET_LOADING, false);
                }
            });

        }
        else{
          this.missing_name_error_message = "Please check if you have filled Page Names in all Languages and filled in at least one Title and Page content for respective Language.";
        }
      },
      update: function() {
        if (this.$refs.form.validate()) {
          let data = {
            id: this.template_id,
            page_type:this.page_type,
            show_on_side_menu:this.show_on_side_menu,
            _method: "put"
          }

          this.availablelanguages.forEach((lang,index) => {
              if(this.page_name[index]){
                this.missing_name_error_message = "";
                  this.page_names.push({
                      "lang_code": lang.lang_code,
                      "page_name": this.page_name[index],
                  })
              }
              else{
                this.missing_name_error_message = "You need to fill Page Names in all Languages. ";
              }
            });
          data["page_names"] = this.page_names;

            if(this.campaignswitch){
              this.additional_pages_template = [];
              this.emailtemplates.forEach((et,noindex) => {
                  this.availablelanguages.forEach((lang,index) => {
                      if(et.page_title[index]!=""){
                          if(et.page_title[index]!=null){
                              this.additional_pages_template.push({
                                  "lang_code": lang.lang_code,
                                  "content_number": noindex+1,
                                  "rank_number": et.rank_number[index],
                                  "page_title": et.page_title[index],
                                  "page_content": et.page_content[index],
                              });
                          }
                      }
                  });
              });
          }
          else{
            this.additional_pages_template = [];
              this.availablelanguages.forEach((lang,index) => {
                if(this.page_title[index]!=""){
                  if(this.page_title[index]!=null){
                    this.additional_pages_template.push({
                        "lang_code": lang.lang_code,
                        "content_number": 1,
                        "rank_number": this.rank_number[index],
                        "page_title": this.page_title[index],
                        "page_content": this.page_content[index],
                    })
                  }
                }
              });
          }

          data["page_contents"] = this.additional_pages_template;

            if(data["page_contents"].length==0){
              this.missing_fields_error_message = "You need to fill the at least one language, Title and Page Contents";
              return;
            }

          if(this.missing_name_error_message){
            return;
          }

            this.$store.dispatch(UPDATE_COMPANY_PAGE, data).then((resp) => {
                if (
                    resp != undefined &&
                    resp.hasOwnProperty("success") &&
                    resp.success
                ) {
                    store.commit(SET_LOADING, false);
                    store.commit(SET_SNACKBAR, {
                    status: true,
                    message: "Page Updated successfully",
                    });
                    this.$router.push({ name: "additionalpages" });
                } else {
                    store.commit(SET_LOADING, false);
                }
            });
       
        }
        else{
          this.missing_name_error_message = "Please check if you have filled Page Names in all Languages and filled in at least one Title and Page content for respective Language.";

        }
      },
      handleDelete(index){
        if(this.campaignswitch){
          this.emailtemplates.splice(index, 1);
        }
      }
  
    },
  };
  </script>
  
  <style scoped>
  [contenteditable] {
    outline: 0px solid transparent;
  }
  .resource-button{
    float: right;
  }
  #custom-tooltip {
      display: none;
      margin-left: 40px;
      padding: 5px 12px;
      background-color: #000000df;
      border-radius: 4px;
      color: #fff;
  }
  </style>